import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PatentSearchDataForm } from '../_models/patent-search-data-form';

@Injectable()
export class PatentSearchService {

  constructor(private http: HttpClient, private authService : AuthService) { }

  public static readonly URL_PATENTSEARCH_CONTROLLER = environment.apiUrl + '/patentsearch/';
  public static readonly URL_PATENT_SEARCH_DOCUMENT_CONTROLLER = environment.apiUrl + '/patentSearchDocuments/';

  public static readonly URL_PATENTSEARCH_LIST = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "all/";
  public static readonly URL_PATENT_SEARCH_BY_ID = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "getById/";
  public static readonly URL_SAVE_AND_UPDATE_PATENT_SEARCH = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "saveUpdate/";
  public static readonly URL_BASIC_INVENTION_DETAILS_BY_ID = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "getPatentSearchByUserId/";
  public static readonly URL_GENERATE_PATENT_SEARCH_PDF = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "generatePatentSearchPdf/";
  public static readonly URL_SAVE_AND_UPDATE_PATENT_SEARCH_DOCUMENT = PatentSearchService.URL_PATENT_SEARCH_DOCUMENT_CONTROLLER + "saveUpdate/";
  public static readonly URL_PATENT_SEARCH_BY_PROJECT_ID = PatentSearchService.URL_PATENTSEARCH_CONTROLLER + "getPatentSearchByProjectID/";

getPatentSearchList() {
  let userToken: string = this.authService.getUserToken();
  return this.http.get(PatentSearchService.URL_PATENTSEARCH_LIST + "/" + userToken,)
   .pipe(catchError(this.handleError('Request Failed')));
}

getPatentSearchById(id) {
  let userToken: string = this.authService.getUserToken();
  return this.http.post(PatentSearchService.URL_PATENT_SEARCH_BY_ID +id + '/'+userToken,id)
    .pipe(catchError(this.handleError('Request Failed')));
}

savePatentSearch(patentSearchDataForm: PatentSearchDataForm) {
  let userToken: string = this.authService.getUserToken();
  return this.http.post(PatentSearchService.URL_SAVE_AND_UPDATE_PATENT_SEARCH + userToken,patentSearchDataForm)
    .pipe(catchError(this.handleError('Request Failed')));
}

generatePatentSearchPDF(id) {
  let userToken: string = this.authService.getUserToken();
  return this.http.post(PatentSearchService.URL_GENERATE_PATENT_SEARCH_PDF + userToken,id)
    .pipe(catchError(this.handleError('Request Failed')));
}

getBasicInventionDetailsByUserID(userDetailsId:number)
  {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentSearchService.URL_BASIC_INVENTION_DETAILS_BY_ID  + '/'+ userDetailsId +'/'+userToken,userDetailsId)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getPatenetSearchByProjectID(projectId)
  {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentSearchService.URL_PATENT_SEARCH_BY_PROJECT_ID  + '/'+ projectId +'/'+userToken,projectId)
      .pipe(catchError(this.handleError('Request Failed')));
  }
  
  
private handleError<T>(operation = 'operation', result?: T) {
  return (error: HttpErrorResponse) => {
    console.log(error);
    if (error.status === 401) {
      localStorage.removeItem('currentUser');
      window.location.replace('');
    }
    return Observable.throw(error);
  };
}

}
